// extracted by mini-css-extract-plugin
module.exports = {"customcb":"tableCheckBox_customcb__1d1-Q"};